<template>
  <el-dialog
    :close-on-click-modal="false"
    title="操作步骤"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="900px"
  >
    <section>
      <img class="introImg" src="~images/getPay/driverSalaryIntro.png" />
      <el-alert
        show-icon
        :closable="false"
        title="如果默认模板能够满足要求，则可以不自定义模板。"
        type="warning" />

      <el-alert
        show-icon
        :closable="false"
        title="操作结算后请通知财务在现金打款中进行线上打款。"
        type="warning" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
    },
  },
};
</script>

<style scoped lang="scss">
.introImg{
  width: 100%;
  margin-bottom: 24px;
}
</style>
